import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  reportConfigurationsRequest: ["businessId"],
  createReportConfigurationRequest: ["businessId", "reportConfiguration"],
  generateReportConfigurationRequest: ["configId", "configName"],
  generateReportConfigurationClearError: [],
  deleteReportConfigurationRequest: ["configId", "businessId"],
  deleteReportConfigurationClearError: [],

  reportConfigurationsSuccess: ["reportConfigurations"],
  createReportConfigurationSuccess: ["reportConfiguration"],
  generateReportConfigurationSuccess: [],
  deleteReportConfigurationSuccess: [],

  reportConfigurationsFailure: ["error"],
  createReportConfigurationFailure: ["error"],
  generateReportConfigurationFailure: ["error"],
  deleteReportConfigurationFailure: ["error"],
});

export const ReportConfigurationTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  fetchingReportConfigurations: false,
  creatingReportConfiguration: false,
  generatingReportConfigurationId: null,
  deletingReportConfigurationId: null,

  reportConfigurations: null,

  errorReportConfigurations: null,
  errorCreateReportConfiguration: null,
  errorGenerateReportConfiguration: null,
  errorDeleteReportConfiguration: null,
});

export const reportConfigurationsRequest = (state) => ({
  ...state,
  fetchingReportConfigurations: true,
  reportConfigurations: null,
  errorReportConfigurations: null,
  errorGenerateReportConfiguration: null,
  errorDeleteReportConfiguration: null,
});

export const generateReportConfigurationClearError = (state) => ({
  ...state,
  errorGenerateReportConfiguration: null,
});

export const deleteReportConfigurationClearError = (state) => ({
  ...state,
  errorDeleteReportConfiguration: null,
});

export const createReportConfigurationRequest = (state) => ({
  ...state,
  creatingReportConfiguration: true,
  errorCreateReportConfiguration: null,
});

export const generateReportConfigurationRequest = (state, action) => {
  const { configId } = action;
  return {
    ...state,
    generatingReportConfigurationId: configId,
    errorGenerateReportConfiguration: null,
  };
};

export const deleteReportConfigurationRequest = (state, action) => {
  const { configId } = action;
  return {
    ...state,
    deletingReportConfigurationId: configId,
    errorDeleteReportConfiguration: null,
  };
};

export const reportConfigurationsSuccess = (state, action) => {
  const { reportConfigurations } = action;
  return {
    ...state,
    fetchingReportConfigurations: false,
    errorReportConfigurations: null,
    reportConfigurations,
  };
};

export const createReportConfigurationSuccess = (state) => ({
  ...state,
  creatingReportConfiguration: false,
  errorCreateReportConfiguration: null,
});

export const generateReportConfigurationSuccess = (state) => ({
  ...state,
  generatingReportConfigurationId: null,
  errorGenerateReportConfiguration: null,
});

export const deleteReportConfigurationSuccess = (state) => ({
  ...state,
  deletingReportConfigurationId: null,
  errorDeleteReportConfiguration: null,
});

export const reportConfigurationsFailure = (state, action) => {
  const { error } = action;
  return {
    ...state,
    fetchingReportConfigurations: false,
    errorReportConfigurations: error,
    reportConfigurations: null,
  };
};

export const createReportConfigurationFailure = (state, action) => {
  const { error } = action;
  return {
    ...state,
    creatingReportConfiguration: false,
    errorCreateReportConfiguration: error,
  };
};

export const generateReportConfigurationFailure = (state, action) => {
  const { error } = action;
  const message = typeof error === "string" ? error : null;
  return {
    ...state,
    generatingReportConfigurationId: null,
    errorGenerateReportConfiguration: message,
  };
};

export const deleteReportConfigurationFailure = (state, action) => {
  const { error } = action;
  return {
    ...state,
    deletingReportConfigurationId: null,
    errorDeleteReportConfiguration: error,
  };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.REPORT_CONFIGURATIONS_REQUEST]: reportConfigurationsRequest,
  [Types.CREATE_REPORT_CONFIGURATION_REQUEST]: createReportConfigurationRequest,
  [Types.GENERATE_REPORT_CONFIGURATION_REQUEST]: generateReportConfigurationRequest,
  [Types.DELETE_REPORT_CONFIGURATION_REQUEST]: deleteReportConfigurationRequest,
  [Types.GENERATE_REPORT_CONFIGURATION_CLEAR_ERROR]:
    generateReportConfigurationClearError,
  [Types.DELETE_REPORT_CONFIGURATION_CLEAR_ERROR]:
    deleteReportConfigurationClearError,

  [Types.REPORT_CONFIGURATIONS_SUCCESS]: reportConfigurationsSuccess,
  [Types.CREATE_REPORT_CONFIGURATION_SUCCESS]: createReportConfigurationSuccess,
  [Types.GENERATE_REPORT_CONFIGURATION_SUCCESS]: generateReportConfigurationSuccess,
  [Types.DELETE_REPORT_CONFIGURATION_SUCCESS]: deleteReportConfigurationSuccess,

  [Types.REPORT_CONFIGURATIONS_FAILURE]: reportConfigurationsFailure,
  [Types.CREATE_REPORT_CONFIGURATION_FAILURE]: createReportConfigurationFailure,
  [Types.GENERATE_REPORT_CONFIGURATION_FAILURE]: generateReportConfigurationFailure,
  [Types.DELETE_REPORT_CONFIGURATION_FAILURE]: deleteReportConfigurationFailure,
});
